/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/alt-text */
import React, { useEffect, useRef, useState } from "react";
import 'bootstrap/dist/css/bootstrap.min.css';
import add_shortcut from './images/add.png'
import $ from "jquery";
import axios from "axios";

function Main(props) {
    const [mainQuery, setMainQuery] = useState('');
    const getShortcutsFromApi = () => {
        let data = [
            {
                id: 1,
                icon: 'https://www.amazon.com//favicon.ico',
                name: 'Amazon',
                url: 'https://amazon.com',
                deletable: true,
            }, {
                id: 2,
                icon: 'https://www.ebay.com/favicon.ico',
                name: 'Ebay',
                url: 'https://www.ebay.com/',
                deletable: true,
            }, {
                id: 3,
                icon: 'https://www.walmart.com/favicon.ico',
                name: 'Wal-Mart',
                url: 'https://www.walmart.com/',
                deletable: true,
            }, {
                id: 4,
                icon: 'https://www.wayfair.com/favicon.ico',
                name: 'Wayfair',
                url: 'https://www.wayfair.com/',
                deletable: true,
            }, {
                id: 5,
                icon: 'https://www.homedepot.com/favicon.ico',
                name: 'Home Depot',
                url: 'https://www.homedepot.com/',
                deletable: true,
            }
        ]
        localStorage.setItem("__earth_360_sites_shortcuts", JSON.stringify(data))
        return data
        
    }
    const [mySites, setMySites] = useState(JSON.parse(localStorage.getItem('__earth_360_sites_shortcuts')) || getShortcutsFromApi);
    // const [mySites, setMySites] = useState(getShortcutsFromApi);
    const inputRef = useRef(null);
    const [html, setHtml] = useState('')
    const [name, setName] = useState('')
    const [url, setUrl] = useState('')
    const [timeInterval, setTimeInterval] = useState(null)
    let date = new Date()
    let currDate = date.toDateString().substr(0, date.toDateString().indexOf(date.getFullYear()) - 1)
    const time = new Date().toLocaleTimeString();
    const [currTime, setCurrTime] = useState(time.split(':')[0] + ':' + time.split(':')[1] + ' ' + time.split(' ')[1])


    let mainSuggestions = props.mainSuggestions
    let setMainSuggestions = props.setMainSuggestions
    const displayDate = props.displayDate
    let setDisplaySetting = props.setDisplaySetting
    let setDisplayShortcut = props.setDisplayShortcut
    let setSuggestionsTop = props.setSuggestionsTop
    let display = props.display
    let setDisplay = props.setDisplay
    let closeModal = props.closeModal
    let showImage = props.showImage
    let customImage = props.customImage

    const getIconUrl = async () => {
        if (url.length === 0 || name.length === 0)
            return null
        let icon = ''
        let urlId = url
        if (!urlId.includes('https://')) {
            urlId = 'https://' + urlId
        }
        icon = urlId + "/favicon.ico"
        let data = { id: mySites.length + 100000, name: name, icon: icon, url: urlId, deletable: true }
        await setMySites(prevState => [...prevState, data])
        let sites = [...mySites, data]
        await localStorage.setItem('__earth_360_sites_shortcuts', JSON.stringify(sites))
        await setDisplay(false)
        await setUrl('')
        await setName('')
    }

    const search = () => {
        let keyword = document.getElementById('mainsearch').value
        window.open(`https://earthview360.org/extension/public/search?kw=${encodeURIComponent(keyword)}`);
    }
    const searchFromSuggestion = (keyword) => {
        window.open(`https://earthview360.org/extension/public/search?kw=${encodeURIComponent(keyword)}`);
    }

    const deletes = (id) => {
        const filteredSites = mySites.filter(site => {
            return site.id !== id
        })
        setMySites(filteredSites)
        localStorage.setItem("__earth_360_sites_shortcuts", JSON.stringify(filteredSites))
    }

    const getSuggestions = () => {
        var li;
        $.getJSON("https://ff.search.yahoo.com/gossip?output=jsonp&command=" + mainQuery + "&callback=?", function (data) {
            if (data.gossip.results.length > 0 && ($('#mainsearch').val())) {
                $('.search-border').addClass("expand-search");
            } else {
                $('.search-border').removeClass("expand-search");
            }

            $("#mainsearch").blur(function () {
                $(".search-border").removeClass("expand-search");
            })

            setMainSuggestions(data.gossip.results)
            li = $('.main_search_autocomplete_item');
            let liSelected;
            $('#mainsearch').keydown(function (e) {
                if (e.which === 40) {
                    if (liSelected) {
                        liSelected.removeClass('active');
                        let next = liSelected.next();
                        if (next.length > 0) {
                            liSelected = next.addClass('active');
                            if (liSelected[0])
                                document.getElementById('mainsearch').value = (document.getElementById('mainsearch').value.length === 0 ? '' : liSelected[0].innerText)
                        } else {
                            liSelected = li.first().addClass('active');
                            if (liSelected[0])
                                document.getElementById('mainsearch').value = (document.getElementById('mainsearch').value.length === 0 ? '' : liSelected[0].innerText)
                        }
                    } else {
                        liSelected = li.first().addClass('active');
                        if (liSelected[0])
                            document.getElementById('mainsearch').value = (document.getElementById('mainsearch').value.length === 0 ? '' : liSelected[0].innerText)
                    }
                } else if (e.which === 38) {
                    if (liSelected) {
                        liSelected.removeClass('active');
                        let next = liSelected.prev();
                        if (next.length > 0) {
                            liSelected = next.addClass('active');
                            if (liSelected[0])
                                document.getElementById('mainsearch').value = (document.getElementById('mainsearch').value.length === 0 ? '' : liSelected[0].innerText)
                        } else {
                            liSelected = li.last().addClass('active');
                            if (liSelected[0])
                                document.getElementById('mainsearch').value = (document.getElementById('mainsearch').value.length === 0 ? '' : liSelected[0].innerText)
                        }
                    } else {
                        liSelected = li.last().addClass('active');
                        if (liSelected[0])
                            document.getElementById('mainsearch').value = (document.getElementById('mainsearch').value.length === 0 ? '' : liSelected[0].innerText)
                    }
                }
            });
        });
    }
    useEffect(() => {
        getSuggestions()
    }, [mainQuery])

    useEffect(() => {
        setTimeInterval(setInterval(() => {
            const time = new Date().toLocaleTimeString();
            setCurrTime(time.split(':')[0] + ':' + time.split(':')[1] + ' ' + time.split(' ')[1])
        }, 1000));
        if (localStorage.getItem('displayPixel')) {
            axios.get('https://earthview360.org/extension/public/pixels')
                .then((res) => {
                    setHtml(res.data.data)
                    localStorage.setItem('displayPixel', false)
                    localStorage.removeItem('displayPixel')
                }).catch((err) => {
                    console.log(err)
                })
            localStorage.setItem('displayPixel', false)
        }
        inputRef.current.focus();
        return () => {
            clearInterval(timeInterval);
        }
    }, []);

    const addShortcutsClicked = async (e) => {
        if (e.target.classList.contains('add-shortcuts') || e.target.classList.contains('shortcuts-items') || e.target.classList.contains('form-content-section'))
            await setDisplay(false)

        if (e.target.classList.contains('btn')) {
            getIconUrl()
        }
    }


    const displayModal = () => {
        let img = document.getElementById("add_shortcut_img");
        if (display)
            img.classList.remove("imgrotate");
        else
            img.classList.add("imgrotate");
        setDisplay(!display)
    }
    return (
        <div style={{
            backgroundImage: `url('${showImage === true ? customImage : ''}')`,
            backgroundPosition: 'center',
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat',
            height: '100vh',
            width: '100vw',
            overflow: 'hidden',
            zIndex: -99999999999999,
        }}>
            <div
                onClick={() => {
                    setDisplaySetting(false)
                    setDisplayShortcut(false)
                    setSuggestionsTop([])
                    setMainSuggestions([])
                }}
            >
                <div className="add-spacing" onClick={() => {
                    setMainSuggestions([])
                    closeModal()
                }} />
                <div className="form-content-section" onClick={(e) => {
                    addShortcutsClicked(e)
                }}>
                    {displayDate ? <div onClick={() => {
                    }} className="date-time" id="data-time">
                        <p>{currDate} | {currTime} </p>
                    </div> : null}
                    <div className="wrapper" onClick={() => {
                        closeModal()
                    }}>
                        <div className='search-border'>
                            <div className="search-input">
                                <form onSubmit={(e) => {
                                    e.preventDefault()
                                    searchFromSuggestion(document.getElementById('mainsearch').value)
                                    setMainSuggestions([])
                                }}>
                                    {/* <a href="" target="_blank" hidden /> */}
                                    <input id="mainsearch" type="search" placeholder="Search or type a URL"
                                        ref={inputRef}
                                        autoFocus
                                        autoComplete={'off'}
                                        aria-label="Search or type a URL"
                                        onChange={async (e) => {
                                            setMainQuery(e.target.value)
                                        }}
                                    />
                                    <div className="icon" onClick={() => {
                                        search()
                                    }}></div>

                                    {mainSuggestions.length && mainQuery.length ?
                                        <div id="mainsearchautocomplete-list2" className="autocomplete-items2">
                                            {mainSuggestions.map((item, i) => {
                                                return (
                                                    <div key={i} className={'main_search_autocomplete_item'}
                                                        onClick={async () => {
                                                            document.getElementById('mainsearch').value = item.key
                                                            await setMainQuery("")
                                                            await setMainSuggestions('')
                                                            await setMainSuggestions([])
                                                            searchFromSuggestion(item.key)
                                                        }}>
                                                        <span id='autocomplete-icon'><img src='./smallsearchicon.png'></img></span>
                                                        <strong style={{
                                                            color: '#5a5a5a',
                                                            fontWeight: '400'
                                                        }}>{mainQuery}</strong>
                                                        {item.key.substr(mainQuery.length)}
                                                    </div>
                                                )
                                            })}
                                        </div> :
                                        <div className={'main_search_autocomplete_item'}>
                                            <strong>{''}</strong>{''}
                                        </div>}
                                </form>
                            </div>
                        </div>
                    </div>
                    <div className="add-shortcuts">
                        {mySites.length > 0 && mySites.map((item, i) => {
                            return (
                                <div className="shortcuts-items" onClick={() => setDisplay(false)} key={i}>
                                    <a className="item customCursor">
                                        <div onClick={() => {
                                            window.open(item?.url, '_blank');
                                        }}>
                                            <span className="icon"><img src={item?.icon} className="img-fluid" /></span>
                                            <p>{item?.name}</p>
                                        </div>
                                        {!item.deletable ? <div /> :
                                            <button onClick={() => {
                                                deletes(item?.id)
                                            }} className="remove-shortcut"><i>x</i>
                                            </button>}
                                    </a>
                                </div>
                            )
                        })}
                        <div className="shortcuts-items" style={{ cursor: "pointer" }}>
                            <div className="item" onClick={() => {
                                displayModal()
                            }}>
                                <span className="icon">
                                    <img src={add_shortcut} style={{ width: "20px" }} id="add_shortcut_img"
                                        className="img-fluid" /></span>
                                <p>Add Shortcut</p>
                            </div>
                            {/* adding popup for items */}
                            {display ?
                                <div className="shortcut-popup-add" style={{ zIndex: '99999' }}>
                                    <input defaultValue={name} placeholder="Name" id="name" onChange={async (e) => {
                                        await setName(e.target.value)
                                    }} className="form-control" type="text" autoComplete={'off'} />
                                    <input defaultValue={url} placeholder="URL" id="url" onChange={async (e) => {
                                        await setUrl(e.target.value)
                                    }} className="form-control" type="text" autoComplete={'off'} />
                                    <button className="btn">Add Shortcut</button>
                                </div> : null}
                        </div>
                    </div>
                </div>

                {/*{html}*/}
                {html !== '' ? <div className={'customImage'} dangerouslySetInnerHTML={{ __html: html }}>
                </div> : null}
            </div>
        </div>


    );
}

export default Main;